import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaV3Provider, getToken } from "firebase/app-check";
import { getRemoteConfig } from "firebase/remote-config";

const firebase = initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
});

const appCheck =
  process.env.NODE_ENV === "production"
    ? initializeAppCheck(firebase, {
        provider: new ReCaptchaV3Provider(process.env.VUE_APP_RECAPTCHA_SITE_ID),
        isTokenAutoRefreshEnabled: true,
      })
    : null;

export const auth = getAuth(firebase);
export const functions = getFunctions(firebase, "asia-northeast1");
export const firestore = getFirestore(firebase);
export const getAppCheckToken = async () => (appCheck ? (await getToken(appCheck)).token : null);
export const remoteConfig = getRemoteConfig(firebase);

remoteConfig.settings.minimumFetchIntervalMillis = (60 * 60 * 1000) / 5;

if (process.env.NODE_ENV === "development") {
  const hostname = window.location.hostname;
  connectAuthEmulator(auth, `http://${hostname}:9099`);
  connectFunctionsEmulator(functions, hostname, 5001);
  connectFirestoreEmulator(firestore, hostname, 8080);

  remoteConfig.settings.minimumFetchIntervalMillis = 5 * 1000;
}

export const authErrorHandler = (e: Error) => {
  const message: Record<string, string> = {
    "auth/provider-already-linked": "選択したサービスのアカウントはリンク済みです",
    "auth/invalid-credential": "無効な認証情報が返されました",
    "auth/credential-already-in-use": "使用したアカウントは既に登録済みです",
    "auth/user-disabled": "アカウントは無効です",
  };
  if ("code" in e && typeof e.code === "string") {
    console.error(e);
    return message[e.code];
  }
  return null;
};
